export default function Settings() {
  return (
    <section className="panel p-5">
      <h3 className="text-base font-semibold">Settings</h3>
      <p className="mt-2 text-sm text-mutedGray dark:text-darkTextSecondary">
        Admin settings scaffold. This area will host feature flags, role mapping, and operational defaults.
      </p>
    </section>
  );
}
